// extracted by mini-css-extract-plugin
export default {"link":"App-Simple-Link_link__Wlq27"};